import { render, staticRenderFns } from "./dicProductButton.vue?vue&type=template&id=10c7fe16&"
import script from "./dicProductButton.vue?vue&type=script&lang=js&"
export * from "./dicProductButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports